import React, { FC } from 'react';
import  styles from './EmailSubscription.module.scss';
import { Card, CardContent, Input } from '@mui/material';


interface EmailSubscriptionProps {
  emailSubscriptionData: {
    title: string;
    description: string;
    inputPlaceholder: string;
    buttonText: string;
  };
}

const EmailSubscription: FC<EmailSubscriptionProps> = ({emailSubscriptionData}) => {

 
  return (
    <Card className="w-full max-w-[1310px] bg-white !rounded-[10px] c-lg:!p-8 !py-8 !px-4  !shadow-[8px_8px_35px_0_rgba(15,44,89,0.07)]">
      <CardContent className="flex flex-col !p-0 items-center gap-8 ">
          <div className="flex flex-col items-center gap-4 w-full">
            <h1 className=" font-bold text-[#0f2c59] c-lg:text-[40px] text-2xl leading-10 text-center">
              {emailSubscriptionData.title}
            </h1>
            <p className="  c-lg:text-2xl text-base text-center  max-w-[887px]">
              {emailSubscriptionData.description}
            </p>
          </div>

          <div className="flex w-full c-lg:flex-row flex-col max-w-[888px] items-center gap-4">
            <input
              className="flex-1 !h-12 bg-white rounded-[10px]  w-full max-c-lg:min-h-12 !border !border-[#436b7b33] ps-3  "
              placeholder={emailSubscriptionData.inputPlaceholder}
            />
            <button className="h-12 px-12 bg-secondary rounded-[48px]  text-primary text-sm">
              {emailSubscriptionData.buttonText}
            </button>
          </div>
      </CardContent>
    </Card>


  );
};



export default EmailSubscription;
